import React, { useState } from "react";
import BOMList from "./components/BOMList";
import BOMForm from "./components/BOMForm";

const BOM = () => {
  const [view, setView] = useState("list");

  return view === "list" ? (
    <BOMList onCreate={() => setView("form")} onEdit={() => setView("form")} />
  ) : (
    <BOMForm onDone={() => setView("list")} />
  );
};

export default BOM;
